/** Manual admin role codes persisted on `users.admin_roles` (must match backend allow-list). */
export const MANUAL_ADMIN_ROLE_CODES = [
  "SUPER_ADMIN",
  "CONTRACT_ADMIN",
  "RFP_ADMIN",
  "PRIZE_RULES_ADMIN",
  "USER_ADMIN"
] as const;

export type ManualAdminRoleCode = (typeof MANUAL_ADMIN_ROLE_CODES)[number];

const LABELS: Record<ManualAdminRoleCode, string> = {
  SUPER_ADMIN: "Super Admin",
  CONTRACT_ADMIN: "Contract Admin",
  RFP_ADMIN: "RFP Admin",
  PRIZE_RULES_ADMIN: "Prize Rules Admin",
  USER_ADMIN: "User Admin"
};

export const manualAdminRoleOptions: readonly { readonly code: ManualAdminRoleCode; readonly label: string }[] =
  MANUAL_ADMIN_ROLE_CODES.map((code) => ({ code, label: LABELS[code] }));
